import { useState, useEffect, useRef, useCallback } from 'react';
import api from '../api';
import { useLab } from '../i18n/LabContext';
import { useLang } from '../i18n/LanguageContext';


function getIsOwner() {
  try {
    const p = JSON.parse(atob(localStorage.getItem('token').split('.')[1]));
    return p?.role === 'owner';
  } catch { return false; }
}

export default function SnackPOS() {
  const isOwner = getIsOwner();
  const [products, setProducts]   = useState([]);
  const [cart, setCart]           = useState([]);
  const [orders, setOrders]       = useState([]);
  const [stats, setStats]         = useState(null);
  const [tab, setTab]             = useState('pos');
  const [filterCat, setFilterCat] = useState('all');
  const [categories, setCategories] = useState([]);
  const [payType, setPayType]     = useState('cash');
  const [pcNum, setPcNum]         = useState('');
  const [isDebt, setIsDebt]       = useState(false);
  const [debtUser, setDebtUser]   = useState(null);
  const [userSearch, setUserSearch] = useState('');
  const [userResults, setUserResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [loading, setLoading]     = useState(false);
  const [productsUnlocked, setProductsUnlocked] = useState(false);
  const [pinModal, setPinModal]   = useState(false);
  const [pinInput, setPinInput]   = useState('');
  const [pinError, setPinError]   = useState('');
  const [newPin, setNewPin]       = useState('');
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [newProduct, setNewProduct] = useState({ name: '', price: '', emoji: '🥤', stock: '', cost_price: '', barcode: '', category_id: '' });
  const [newCategory, setNewCategory] = useState({ name: '', name_ru: '', icon: '🥤', sort_order: '' });
  const [editingCatId, setEditingCatId] = useState(null);
  const [editCatForm, setEditCatForm] = useState({ name: '', name_ru: '', icon: '', sort_order: '' });
  const [barcodeInput, setBarcodeInput] = useState('');
  const [barcodeFlash, setBarcodeFlash] = useState(null);
  const barcodeRef = useRef(null);
  const [shortage, setShortage]         = useState([]);
  const [autoFetching, setAutoFetching] = useState(null); // product id — auto-photo fetch loading
  const [invMode, setInvMode]           = useState('history');
  const [invCounts, setInvCounts]       = useState({});
  const [invNote, setInvNote]           = useState('');
  const [invHistory, setInvHistory]     = useState([]);
  const [invDetail, setInvDetail]       = useState(null);
  const [invSaving, setInvSaving]       = useState(false);
  const [shiftOpenModal, setShiftOpenModal] = useState(false);
  const [shiftCloseModal, setShiftCloseModal] = useState(false);
  const [shiftCashier, setShiftCashier]     = useState('');
  const [shiftOpenCash, setShiftOpenCash]   = useState('');
  const [shiftCloseCash, setShiftCloseCash] = useState('');
  // Smena yopishda to'lov turi bo'yicha breakdown (kassa smenasiga o'xshash).
  // Backend /snack/shifts/current avtomatik revenue_cash/click/payme/terminal
  // qaytaradi — modal ochilganda bu qiymatlar bilan avtomat to'ldiriladi.
  const [shiftCloseClick, setShiftCloseClick]       = useState('');
  const [shiftClosePayme, setShiftClosePayme]       = useState('');
  const [shiftCloseTerminal, setShiftCloseTerminal] = useState('');
  const [staffList, setStaffList]           = useState([]);
  const [currentShift, setCurrentShift] = useState(null);
  const [shiftOrders, setShiftOrders]   = useState([]);
  const [returnModal, setReturnModal]   = useState(null);
  const [returnItems, setReturnItems]   = useState({});
  const [returnReason, setReturnReason] = useState('');
  const [shiftLoading, setShiftLoading] = useState(false);
  const [shiftHistory, setShiftHistory]     = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [expandedShiftId, setExpandedShiftId] = useState(null);
  const [historyOrders, setHistoryOrders]   = useState({});
  const [editingId, setEditingId]           = useState(null);
  const [editForm, setEditForm]             = useState({});
  const [editSaving, setEditSaving]         = useState(false);
  const [returnListModal, setReturnListModal] = useState(false);
  const [paidOrders, setPaidOrders]         = useState([]);
  const [paidLoading, setPaidLoading]       = useState(false);
  const { labs, labId, mode: labMode, refreshLabs } = useLab();
  // "Hammasi" rejim — 2+ klubli ega, aniq klub tanlanmagan. Yozish amallari
  // (smena ochish/yopish/orders) backend tomondan 400 qaytaradi. UI'da tugma
  // ko'rsatish o'rniga tushuntiruv yozuv (2.2 bosqich).
  const isAllMode = labMode === 'all';
  const { t, lang } = useLang();
  const catName = (c) => (lang === 'ru' && c?.name_ru) ? c.name_ru : (c?.name || '');

  useEffect(() => {
    if (!labId) return;
    Promise.all([
      api.get('/snack/products?active=true'),
      api.get('/snack/categories'),
      api.get('/snack/orders?status=open&limit=20'),
      api.get('/snack/stats'),
      api.get(`/snack/shifts/current?lab_id=${labId}`),
    ]).then(([p, c, o, s, sh]) => {
      setProducts(p.data.filter(x => x.lab_id === labId));
      setCategories(c.data.filter(x => x.lab_id === labId));
      setOrders(o.data.filter(x => x.lab_id === labId));
      setStats(s.data);
      setCurrentShift(sh.data);
    }).catch(() => {});
  }, [labId]);

  const loadShift = async () => {
    const sh = await api.get(`/snack/shifts/current?lab_id=${labId}`);
    setCurrentShift(sh.data);
    if (sh.data) {
      const ord = await api.get(`/snack/shifts/${sh.data.id}/orders`);
      setShiftOrders(ord.data);
    } else {
      setShiftOrders([]);
    }
  };

  const loadShiftHistory = async () => {
    setHistoryLoading(true);
    try {
      const r = await api.get('/snack/shifts?limit=30');
      setShiftHistory(r.data || []);
    } catch { /* ignore */ }
    finally { setHistoryLoading(false); }
  };

  const toggleShiftDetails = async (shiftId) => {
    if (expandedShiftId === shiftId) {
      setExpandedShiftId(null);
      return;
    }
    setExpandedShiftId(shiftId);
    if (!historyOrders[shiftId]) {
      try {
        const r = await api.get(`/snack/shifts/${shiftId}/orders`);
        setHistoryOrders(prev => ({ ...prev, [shiftId]: r.data || [] }));
      } catch {
        setHistoryOrders(prev => ({ ...prev, [shiftId]: [] }));
      }
    }
  };

  const openShift = async () => {
    if (!shiftCashier.trim()) { alert(t('snackAlertAdminName')); return; }
    setShiftLoading(true);
    try {
      await api.post('/snack/shifts/open', {
        lab_id: labId,
        cashier_name: shiftCashier.trim(),
        opening_cash: parseFloat(shiftOpenCash) || 0,
      });
      setShiftOpenModal(false);
      setShiftCashier(''); setShiftOpenCash('');
      await loadShift();
      loadShiftHistory();
    } catch (e) { alert(e.response?.data?.error || t('error')); }
    finally { setShiftLoading(false); }
  };

  // Smena yopish modali ochilganda inputlarni avtomat to'ldirish — backend
  // revenue_cash/click/payme/terminal'ni smena davridagi haqiqiy summalardan
  // hisoblab qaytaradi. Admin kerak bo'lsa inputda to'g'rilashi mumkin.
  const openCloseShiftModal = () => {
    const _n = v => Number(v || 0);
    if (currentShift) {
      // Naqd kutilgan summa: ochilish naqdi + naqd buyurtmalar - qaytarishlar
      const expectedCash = Math.max(0,
        _n(currentShift.opening_cash) + _n(currentShift.revenue_cash) - _n(currentShift.returns_total));
      setShiftCloseCash(expectedCash ? String(Math.round(expectedCash)) : '');
      setShiftCloseClick(_n(currentShift.revenue_click)       ? String(Math.round(_n(currentShift.revenue_click)))       : '');
      setShiftClosePayme(_n(currentShift.revenue_payme)       ? String(Math.round(_n(currentShift.revenue_payme)))       : '');
      setShiftCloseTerminal(_n(currentShift.revenue_terminal) ? String(Math.round(_n(currentShift.revenue_terminal)))    : '');
    } else {
      setShiftCloseCash(''); setShiftCloseClick(''); setShiftClosePayme(''); setShiftCloseTerminal('');
    }
    setShiftCloseModal(true);
  };

  const closeShift = async () => {
    if (!currentShift) return;
    setShiftLoading(true);
    try {
      await api.post(`/snack/shifts/${currentShift.id}/close`, {
        closing_cash:     parseFloat(shiftCloseCash)     || 0,
        closing_click:    parseFloat(shiftCloseClick)    || 0,
        closing_payme:    parseFloat(shiftClosePayme)    || 0,
        closing_terminal: parseFloat(shiftCloseTerminal) || 0,
      });
      setShiftCloseModal(false);
      setShiftCloseCash('');
      setShiftCloseClick('');
      setShiftClosePayme('');
      setShiftCloseTerminal('');
      await loadShift();
      loadShiftHistory();
    } catch (e) { alert(e.response?.data?.error || t('error')); }
    finally { setShiftLoading(false); }
  };

  const startEditProduct = (p) => {
    setEditingId(p.id);
    setEditForm({
      name: p.name || '',
      price: p.price ?? '',
      cost_price: p.cost_price ?? '',
      stock: p.stock ?? 0,
      emoji: p.emoji || '🥤',
      barcode: p.barcode || '',
      category_id: p.category_id ?? '',
    });
  };

  const cancelEditProduct = () => {
    setEditingId(null);
    setEditForm({});
  };

  const saveEditProduct = async (id) => {
    if (!editForm.name?.trim()) { alert(t('snackAlertName') || 'Nomi kerak'); return; }
    if (editForm.price === '' || isNaN(parseFloat(editForm.price))) {
      alert(t('snackAlertPrice') || "Narx noto'g'ri"); return;
    }
    setEditSaving(true);
    try {
      const payload = {
        name: editForm.name.trim(),
        price: parseFloat(editForm.price),
        cost_price: editForm.cost_price === '' ? 0 : parseFloat(editForm.cost_price),
        stock: editForm.stock === '' ? 0 : parseInt(editForm.stock),
        emoji: editForm.emoji,
        barcode: editForm.barcode?.trim() || null,
        category_id: editForm.category_id === '' ? null : parseInt(editForm.category_id, 10),
      };
      const r = await api.put(`/snack/products/${id}`, payload);
      setProducts(prev => prev.map(x => x.id === id ? { ...x, ...r.data } : x));
      cancelEditProduct();
    } catch (e) {
      alert(e.response?.data?.error || t('error'));
    } finally {
      setEditSaving(false);
    }
  };

  const openReturnModal = async (order) => {
    const items = {};
    (order.items || []).forEach(i => { items[i.id] = 0; });
    setReturnItems(items);
    setReturnReason('');
    setReturnModal(order);
  };

  const openReturnList = async () => {
    setReturnListModal(true);
    setPaidLoading(true);
    try {
      const r = await api.get('/snack/orders?status=paid&limit=50');
      setPaidOrders((r.data || []).filter(o => !labId || o.lab_id === labId));
    } catch (e) {
      alert(e.response?.data?.error || t('error'));
    } finally {
      setPaidLoading(false);
    }
  };

  const selectOrderForReturn = (order) => {
    setReturnListModal(false);
    openReturnModal(order);
  };

  const submitReturn = async () => {
    const toReturn = (returnModal.items || []).filter(i => returnItems[i.id] > 0).map(i => ({
      order_item_id: i.id,
      product_id: i.product_id,
      product_name: i.product_name,
      qty: returnItems[i.id],
      amount: i.price * returnItems[i.id],
    }));
    if (!toReturn.length) { alert(t('snackAlertReturnSelect')); return; }
    try {
      await api.post('/snack/returns', { order_id: returnModal.id, items: toReturn, reason: returnReason });
      setReturnModal(null);
      await loadShift();
    } catch (e) { alert(e.response?.data?.error || t('error')); }
  };

  const onBarcodeEnter = useCallback(async (code) => {
    if (!code.trim()) return;
    setBarcodeInput('');
    try {
      const r = await api.get(`/snack/products/barcode/${encodeURIComponent(code.trim())}`);
      const p = r.data;
      addToCartDirect(p);
      setBarcodeFlash({ name: p.name, ok: true });
    } catch {
      setBarcodeFlash({ name: code, ok: false });
    }
    setTimeout(() => setBarcodeFlash(null), 2000);
  }, []);  // eslint-disable-line

  useEffect(() => {
    if (tab !== 'pos') return;
    const handler = (e) => {
      const tag = document.activeElement?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      if (e.key === 'Enter') return;
      barcodeRef.current?.focus();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [tab]);

  const addToCartDirect = (p) => {
    setCart(prev => {
      const ex = prev.find(i => i.product_id === p.id);
      if (ex) return prev.map(i => i.product_id === p.id ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { product_id: p.id, name: p.name, price: p.price, emoji: p.emoji, qty: 1 }];
    });
  };

  const searchUsers = async (q) => {
    setUserSearch(q);
    if (!q.trim()) { setUserResults([]); return; }
    setSearchLoading(true);
    try {
      const r = await api.get(`/owner/clients?q=${encodeURIComponent(q)}&limit=6`);
      setUserResults(r.data.users || []);
    } catch {} finally { setSearchLoading(false); }
  };

  const selectDebtUser = (u) => {
    setDebtUser(u); setUserSearch(''); setUserResults([]);
  };

  const addToCart = (p) => {
    setCart(prev => {
      const ex = prev.find(i => i.product_id === p.id);
      if (ex) return prev.map(i => i.product_id === p.id ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { product_id: p.id, name: p.name, price: p.price, emoji: p.emoji, qty: 1 }];
    });
  };

  const changeQty = (pid, delta) => {
    setCart(prev => prev
      .map(i => i.product_id === pid ? { ...i, qty: i.qty + delta } : i)
      .filter(i => i.qty > 0)
    );
  };

  const cartTotal = cart.reduce((s, i) => s + i.price * i.qty, 0);

  const checkout = async () => {
    if (!cart.length) return;
    if (isDebt && !debtUser) { alert(t('snackAlertDebtUser')); return; }
    const wasDebt = isDebt;
    setLoading(true);
    try {
      await api.post('/snack/orders', {
        lab_id: labId,
        items: cart.map(i => ({ product_id: i.product_id, qty: i.qty })),
        computer_number: pcNum || null,
        payment_type: wasDebt ? 'debt' : payType,
        is_debt: wasDebt,
        user_id: debtUser?.id || null,
      });
      setCart([]);
      setPcNum('');
      setIsDebt(false);
      setDebtUser(null);
      setUserSearch('');
      const [o, s] = await Promise.all([
        api.get('/snack/orders?status=open&limit=20'),
        api.get('/snack/stats'),
      ]);
      setOrders(o.data.filter(x => x.lab_id === labId));
      setStats(s.data);
      if (!wasDebt) {
        setBarcodeFlash({ name: t('snackSoldFlash'), ok: true });
        setTimeout(() => setBarcodeFlash(null), 1500);
      }
    } catch (e) {
      alert(e.response?.data?.error || t('error'));
    } finally { setLoading(false); }
  };

  const payOrder = async (orderId) => {
    try {
      await api.post(`/snack/orders/${orderId}/pay`, { payment_type: 'cash' });
      setOrders(prev => prev.filter(o => o.id !== orderId));
      const s = await api.get('/snack/stats');
      setStats(s.data);
    } catch (e) { alert(e.response?.data?.error || t('error')); }
  };

  const addProduct = async () => {
    if (!newProduct.name || !newProduct.price) return;
    if (!newProduct.category_id) { alert(t('snackCategoryRequired')); return; }
    try {
      const payload = {
        lab_id: labId,
        ...newProduct,
        price: parseFloat(newProduct.price),
        category_id: parseInt(newProduct.category_id, 10),
      };
      const r = await api.post('/snack/products', payload);
      setProducts(prev => [...prev, r.data]);
      setNewProduct({ name: '', price: '', emoji: '🥤', stock: '', cost_price: '', barcode: '', category_id: '' });
      setShowAddProduct(false);
    } catch (e) { alert(e.response?.data?.error || t('error')); }
  };

  // ── Kategoriya CRUD ──────────────────────────────────────────────────────
  const addCategory = async () => {
    if (!newCategory.name) { alert(t('snackCatNameRequired')); return; }
    try {
      const r = await api.post('/snack/categories', {
        lab_id: labId,
        name: newCategory.name,
        name_ru: newCategory.name_ru || null,
        icon: newCategory.icon || '🥤',
        sort_order: parseInt(newCategory.sort_order, 10) || (categories.length + 1),
      });
      setCategories(prev => [...prev, r.data].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)));
      setNewCategory({ name: '', name_ru: '', icon: '🥤', sort_order: '' });
    } catch (e) { alert(e.response?.data?.error || t('error')); }
  };

  const startEditCat = (c) => {
    setEditingCatId(c.id);
    setEditCatForm({ name: c.name || '', name_ru: c.name_ru || '', icon: c.icon || '🥤', sort_order: c.sort_order || '' });
  };

  const saveEditCat = async () => {
    try {
      const r = await api.put(`/snack/categories/${editingCatId}`, {
        name: editCatForm.name,
        name_ru: editCatForm.name_ru,
        icon: editCatForm.icon,
        sort_order: parseInt(editCatForm.sort_order, 10) || 0,
      });
      setCategories(prev => prev.map(x => x.id === editingCatId ? r.data : x)
        .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0)));
      setEditingCatId(null);
    } catch (e) { alert(e.response?.data?.error || t('error')); }
  };

  const deleteCat = async (c) => {
    if (!window.confirm(t('snackCatDeleteConfirm').replace('{name}', catName(c)))) return;
    try {
      await api.delete(`/snack/categories/${c.id}`);
      setCategories(prev => prev.filter(x => x.id !== c.id));
      setProducts(prev => prev.map(p => p.category_id === c.id ? { ...p, category_id: null } : p));
    } catch (e) { alert(e.response?.data?.error || t('error')); }
  };

  const filteredProducts = filterCat === 'all'
    ? products
    : products.filter(p => p.category_id === filterCat);

  const handlePin = () => {
    if (pinModal === 'change') {
      if (!newPin.trim()) { setPinError(t('snackPinEmpty')); return; }
      localStorage.setItem('snack_pin', newPin.trim());
      setPinModal(false); setNewPin(''); setPinError('');
      alert(t('snackPinChanged'));
    } else {
      const saved = localStorage.getItem('snack_pin') || '1234';
      if (pinInput === saved) {
        setProductsUnlocked(true); setTab('products'); setPinModal(false); setPinInput(''); setPinError('');
      } else {
        setPinError(t('snackPinWrong')); setPinInput('');
      }
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700 }}>{t('snackTitle')}</h1>
          <div style={{ color: 'var(--text2)', fontSize: 13, marginTop: 4 }}>{t('snackSubtitle')}</div>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {isAllMode ? (
            <div style={{
              background: 'rgba(0,212,255,0.08)', border: '1.5px solid var(--cyan)',
              color: 'var(--cyan)', padding: '6px 14px', borderRadius: 8, fontSize: 12, fontWeight: 700,
            }}>🌐 {t('selectLabForShift') || 'Smenani boshqarish uchun klubni tanlang'}</div>
          ) : currentShift ? (
            <button onClick={openCloseShiftModal} style={{
              background: 'rgba(0,255,136,0.1)', border: '1.5px solid var(--green)',
              color: 'var(--green)', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700,
            }}>{t('snackShiftOpen')}</button>
          ) : (
            <button onClick={() => {
              setShiftCashier(''); setShiftOpenCash(''); setShiftOpenModal(true);
              const ownerData = JSON.parse(localStorage.getItem('owner') || '{}');
              const ownerEntry = ownerData.name ? [{ id: 'owner', name: ownerData.name, role: 'Admin' }] : [];
              api.get('/staff').then(r => setStaffList([...ownerEntry, ...(r.data || [])])).catch(() => setStaffList(ownerEntry));
            }} style={{
              background: 'rgba(239,68,68,0.1)', border: '1.5px solid #ef4444',
              color: '#ef4444', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700,
            }}>{t('snackShiftClosed')}</button>
          )}
          {isOwner && (() => {
            const curLab = labs.find(l => String(l.id) === String(labId));
            if (!curLab) return null;
            const on = curLab.snack_enabled !== false;
            return (
              <button
                onClick={async () => {
                  try {
                    await api.patch(`/owner/labs/${labId}/settings`, { snack_enabled: !on });
                    refreshLabs();
                  } catch (e) { alert(e.response?.data?.error || t('error')); }
                }}
                title={on ? t('snackCompOrderOnHint') : t('snackCompOrderOffHint')}
                style={{
                  background: on ? 'rgba(0,255,136,0.1)' : 'rgba(255,255,255,0.04)',
                  border: `1.5px solid ${on ? 'var(--green)' : 'var(--border)'}`,
                  color: on ? 'var(--green)' : 'var(--text3)',
                  padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700,
                }}>
                {on ? t('snackCompOrderOn') : t('snackCompOrderOff')}
              </button>
            );
          })()}
        </div>
      </div>


      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {[
          ['pos', t('snackTabPos')],
          ['orders', `📋 ${t('snackTabOrders')} (${orders.length})`],
          ['smena', `⏱ ${t('snackTabSmena')}${currentShift ? ' ●' : ''}`],
          ['products', `🔒 ${t('snackTabProducts')}`],
          ['cats', `🏷 ${t('snackTabCats')}`],
          ['shortage', `⚠ ${t('snackTabShortage')}`],
          ['stats', `📊 ${t('snackTabStats')}`],
        ].map(([k, l]) => (
          <button key={k} onClick={() => {
            if (k === 'products' && !productsUnlocked) {
              setPinInput(''); setPinError(''); setPinModal('enter');
            } else {
              setTab(k);
              if (k === 'shortage') {
                api.get('/snack/shortage').then(r => setShortage(r.data)).catch(() => {});
                api.get('/snack/inventory').then(r => setInvHistory(r.data)).catch(() => {});
                setInvMode('history');
              }
              if (k === 'smena') {
                loadShift();
                loadShiftHistory();
              }
            }
          }} style={{
            padding: '7px 16px', borderRadius: 8, fontSize: 12, cursor: 'pointer',
            background: tab === k ? 'rgba(0,212,255,0.1)' : 'transparent',
            border: `1px solid ${tab === k ? 'var(--cyan)' : 'var(--border)'}`,
            color: tab === k ? 'var(--cyan)' : 'var(--text2)',
          }}>{l}</button>
        ))}
      </div>

      {/* ── POS ─────────────────────────────────────────────────── */}
      {tab === 'pos' && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 20 }}>
          <div>
            <div style={{ marginBottom: 14, position: 'relative' }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <div style={{ position: 'relative', flex: 1 }}>
                  <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 16 }}>📷</span>
                  <input
                    ref={barcodeRef}
                    value={barcodeInput}
                    onChange={e => setBarcodeInput(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); onBarcodeEnter(barcodeInput); } }}
                    placeholder={t('snackBarcodePlh')}
                    style={{
                      width: '100%', boxSizing: 'border-box',
                      background: 'var(--card2)', border: `1.5px solid ${barcodeFlash ? (barcodeFlash.ok ? 'var(--green)' : '#ef4444') : 'var(--border)'}`,
                      color: 'var(--text)', padding: '10px 14px 10px 38px',
                      borderRadius: 10, fontSize: 14, outline: 'none',
                      transition: 'border-color 0.2s',
                    }}
                  />
                </div>
                {barcodeFlash && (
                  <div style={{
                    padding: '8px 16px', borderRadius: 10, fontSize: 13, fontWeight: 700,
                    background: barcodeFlash.ok ? 'rgba(0,255,136,0.15)' : 'rgba(239,68,68,0.15)',
                    color: barcodeFlash.ok ? 'var(--green)' : '#ef4444',
                    border: `1px solid ${barcodeFlash.ok ? 'var(--green)' : '#ef4444'}`,
                    whiteSpace: 'nowrap',
                  }}>
                    {barcodeFlash.ok ? `✓ ${barcodeFlash.name}` : `✗ ${t('snackNotFound')}: ${barcodeFlash.name}`}
                  </div>
                )}
              </div>
            </div>

            <div style={{ display: 'flex', gap: 8, marginBottom: 12, justifyContent: 'flex-end' }}>
              <button onClick={openReturnList} style={{
                background: 'rgba(239,68,68,0.1)', border: '1.5px solid #ef4444',
                color: '#ef4444', padding: '7px 18px', borderRadius: 8, cursor: 'pointer',
                fontSize: 12, fontWeight: 700,
              }}>↩ {t('snackReturnBtn') || 'Vazvrat'}</button>
            </div>

            <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
              <button onClick={() => setFilterCat('all')} style={{
                padding: '4px 12px', borderRadius: 20, fontSize: 11, cursor: 'pointer',
                background: filterCat === 'all' ? 'rgba(0,212,255,0.15)' : 'transparent',
                border: `1px solid ${filterCat === 'all' ? 'var(--cyan)' : 'var(--border)'}`,
                color: filterCat === 'all' ? 'var(--cyan)' : 'var(--text2)',
              }}>{t('snackAllCats')}</button>
              {categories.map(c => (
                <button key={c.id} onClick={() => setFilterCat(c.id)} style={{
                  padding: '4px 12px', borderRadius: 20, fontSize: 11, cursor: 'pointer',
                  background: filterCat === c.id ? 'rgba(0,212,255,0.15)' : 'transparent',
                  border: `1px solid ${filterCat === c.id ? 'var(--cyan)' : 'var(--border)'}`,
                  color: filterCat === c.id ? 'var(--cyan)' : 'var(--text2)',
                }}>{c.icon} {catName(c)}</button>
              ))}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: 10 }}>
              {filteredProducts.map(p => (
                <button key={p.id} onClick={() => addToCart(p)} style={{
                  background: 'var(--card2)', border: '1px solid var(--border)',
                  borderRadius: 12, padding: '14px 10px', cursor: 'pointer',
                  textAlign: 'center', transition: 'border-color 0.15s',
                }} onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--cyan)'}
                   onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}>
                  <div style={{ fontSize: 28, marginBottom: 6 }}>{p.emoji}</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>{p.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--green)', fontWeight: 600 }}>
                    {Number(p.price).toLocaleString()} {t('currency')}
                  </div>
                  {p.stock > 0 && <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 2 }}>{t('snackStockLeft')} {p.stock}</div>}
                </button>
              ))}
              {filteredProducts.length === 0 && (
                <div style={{ gridColumn: '1/-1', padding: 32, textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>
                  {t('snackNoProducts')}
                </div>
              )}
            </div>
          </div>

          {/* Savat / Cart */}
          <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 14, padding: 20, height: 'fit-content', position: 'sticky', top: 20 }}>
            <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 16 }}>{t('snackCart')}</div>

            {cart.length === 0 ? (
              <div style={{ textAlign: 'center', color: 'var(--text3)', fontSize: 12, padding: '24px 0' }}>
                {t('snackPickProduct')}
              </div>
            ) : (
              <>
                {cart.map(item => (
                  <div key={item.product_id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 12, fontWeight: 600 }}>{item.emoji} {item.name}</div>
                      <div style={{ fontSize: 11, color: 'var(--text3)' }}>{Number(item.price * item.qty).toLocaleString()} {t('currency')}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <button onClick={() => changeQty(item.product_id, -1)} style={{ width: 24, height: 24, borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text)', cursor: 'pointer', fontSize: 14 }}>−</button>
                      <span style={{ fontSize: 13, minWidth: 20, textAlign: 'center' }}>{item.qty}</span>
                      <button onClick={() => changeQty(item.product_id, 1)} style={{ width: 24, height: 24, borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text)', cursor: 'pointer', fontSize: 14 }}>+</button>
                    </div>
                  </div>
                ))}

                <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 4 }}>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                    <input value={pcNum} onChange={e => setPcNum(e.target.value)} placeholder={t('snackPcPlh')}
                      style={{ flex: 1, background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '6px 10px', borderRadius: 8, fontSize: 11 }} />
                  </div>

                  {!isDebt && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, marginBottom: 10 }}>
                      {[
                        { k: 'cash',     l: t('snackPayCash'),     c: 'var(--green)'  },
                        { k: 'click',    l: 'Click',               c: 'var(--blue)'   },
                        { k: 'payme',    l: 'Payme',               c: 'var(--purple)' },
                        { k: 'terminal', l: t('snackPayTerminal'), c: 'var(--cyan)'   },
                      ].map(({ k, l, c }) => (
                        <button key={k} onClick={() => setPayType(k)} style={{
                          padding: '5px', borderRadius: 7, fontSize: 11, fontWeight: 600, cursor: 'pointer',
                          background: payType === k ? `color-mix(in srgb, ${c} 15%, transparent)` : 'transparent',
                          border: `1px solid ${payType === k ? c : 'var(--border)'}`,
                          color: payType === k ? c : 'var(--text2)',
                          transition: 'all 0.15s',
                        }}>{l}</button>
                      ))}
                    </div>
                  )}

                  <button onClick={() => { setIsDebt(v => !v); setDebtUser(null); setUserSearch(''); }} style={{
                    width: '100%', marginBottom: 10, padding: '7px',
                    background: isDebt ? 'rgba(239,68,68,0.15)' : 'transparent',
                    border: `1.5px solid ${isDebt ? '#ef4444' : 'var(--border)'}`,
                    color: isDebt ? '#ef4444' : 'var(--text2)',
                    borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: isDebt ? 700 : 400,
                  }}>
                    {isDebt ? t('snackDebtOn') : t('snackDebtOff')}
                  </button>

                  {isDebt && (
                    <div style={{ marginBottom: 10, position: 'relative' }}>
                      {debtUser ? (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, padding: '7px 10px' }}>
                          <div>
                            <div style={{ fontSize: 12, fontWeight: 700, color: '#ef4444' }}>{debtUser.name}</div>
                            <div style={{ fontSize: 10, color: '#f87171' }}>{debtUser.phone}</div>
                          </div>
                          <button onClick={() => setDebtUser(null)} style={{ background: 'transparent', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: 16 }}>✕</button>
                        </div>
                      ) : (
                        <>
                          <input
                            value={userSearch}
                            onChange={e => searchUsers(e.target.value)}
                            placeholder={t('snackDebtUserPlh')}
                            style={{ width: '100%', background: 'var(--bg2)', border: '1.5px solid rgba(239,68,68,0.5)', color: 'var(--text)', padding: '7px 10px', borderRadius: 8, fontSize: 12, boxSizing: 'border-box', outline: 'none' }}
                          />
                          {userResults.length > 0 && (
                            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 8, zIndex: 50, maxHeight: 160, overflowY: 'auto', marginTop: 2 }}>
                              {userResults.map(u => (
                                <div key={u.id} onClick={() => selectDebtUser(u)} style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 12, borderBottom: '1px solid var(--border)' }}
                                  onMouseEnter={e => e.currentTarget.style.background = 'var(--card2)'}
                                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                                  <div style={{ fontWeight: 600 }}>{u.name}</div>
                                  <div style={{ color: 'var(--text3)', fontSize: 11 }}>{u.phone}</div>
                                </div>
                              ))}
                            </div>
                          )}
                          {searchLoading && <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 4 }}>{t('snackSearching')}</div>}
                          <div style={{ fontSize: 11, color: '#f87171', marginTop: 4 }}>{t('snackDebtUserRequired')}</div>
                        </>
                      )}
                    </div>
                  )}

                  <div style={{ fontSize: 16, fontWeight: 700, color: isDebt ? '#ef4444' : 'var(--green)', textAlign: 'right', marginBottom: 12 }}>
                    {cartTotal.toLocaleString()} {t('currency')} {isDebt ? t('snackDebtLabel') : ''}
                  </div>

                  <button onClick={checkout} disabled={loading || (isDebt && !debtUser)} style={{
                    width: '100%', border: 'none', color: isDebt ? '#fff' : '#000',
                    padding: '10px', borderRadius: 10, cursor: (loading || (isDebt && !debtUser)) ? 'not-allowed' : 'pointer',
                    fontSize: 13, fontWeight: 700,
                    background: isDebt
                      ? (loading || !debtUser ? 'rgba(239,68,68,0.3)' : '#ef4444')
                      : 'var(--green)',
                    opacity: loading ? 0.6 : 1,
                  }}>{isDebt ? t('snackSaveDebt') : t('snackSell')}</button>
                  <button onClick={() => setCart([])} style={{
                    width: '100%', marginTop: 6, background: 'transparent', border: '1px solid var(--border)',
                    color: 'var(--text2)', padding: '7px', borderRadius: 8, cursor: 'pointer', fontSize: 12,
                  }}>{t('snackClear')}</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── OCHIQ BUYURTMALAR ───────────────────────────────────── */}
      {tab === 'orders' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
          {orders.length === 0 ? (
            <div style={{ gridColumn: '1/-1', background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 14, padding: 40, textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>
              {t('snackNoOpenOrders')}
            </div>
          ) : orders.map(order => (
            <div key={order.id} style={{ background: order.is_debt ? 'rgba(239,68,68,0.05)' : 'var(--card2)', border: `1px solid ${order.is_debt ? 'rgba(239,68,68,0.4)' : 'var(--border)'}`, borderRadius: 12, padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                <span style={{ fontFamily: 'Orbitron, sans-serif', color: order.is_debt ? '#ef4444' : 'var(--cyan)', fontSize: 12, fontWeight: 700 }}>
                  {order.is_debt ? `${t('snackDebtBadge')} · ` : ''}#{order.id} {order.computer_number ? `· PC ${order.computer_number}` : ''}
                </span>
                <span style={{ fontSize: 10, color: 'var(--text3)' }}>
                  {new Date(order.created_at).toLocaleTimeString('uz-UZ', { hour: '2-digit', minute: '2-digit' })}
                </span>
              </div>
              {order.is_debt && order.user_name && (
                <div style={{ fontSize: 12, color: '#f87171', fontWeight: 600, marginBottom: 8 }}>👤 {order.user_name}</div>
              )}
              <div style={{ marginBottom: 12 }}>
                {(order.items || []).map((item, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 3 }}>
                    <span style={{ color: 'var(--text2)' }}>{item.product_name} ×{item.qty}</span>
                    <span>{Number(item.subtotal).toLocaleString()}</span>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 700, color: 'var(--green)' }}>{Number(order.total).toLocaleString()} {t('currency')}</span>
                <button onClick={() => payOrder(order.id)} style={{
                  background: 'rgba(0,255,136,0.12)', border: '1px solid var(--green)',
                  color: 'var(--green)', padding: '5px 12px', borderRadius: 7, cursor: 'pointer', fontSize: 11,
                }}>{t('snackPaid')}</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Smena ochish modali */}
      {shiftOpenModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16, padding: 32, width: 380 }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 24 }}>{t('snackOpenShiftTitle')}</div>
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 6 }}>{t('snackAdminLabel')}</div>
              {staffList.length > 0 ? (
                <select autoFocus value={shiftCashier} onChange={e => setShiftCashier(e.target.value)}
                  style={{ width: '100%', background: 'var(--bg2)', border: '1.5px solid var(--border)', color: shiftCashier ? 'var(--text)' : 'var(--text3)', padding: '10px 14px', borderRadius: 10, fontSize: 14, outline: 'none', cursor: 'pointer' }}>
                  <option value="">{t('snackSelectAdmin')}</option>
                  {staffList.map(s => (
                    <option key={s.id} value={s.name}>{s.name}{s.role ? ` · ${s.role}` : ''}</option>
                  ))}
                </select>
              ) : (
                <div>
                  <input autoFocus value={shiftCashier} onChange={e => setShiftCashier(e.target.value)}
                    placeholder={t('snackAdminPlh')}
                    style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1.5px solid var(--border)', color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 14, outline: 'none' }} />
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>
                    {t('snackNoStaff')} <a href="/staff" style={{ color: 'var(--cyan)' }}>{t('snackGoStaffPage')}</a> {t('snackOrManual')}
                  </div>
                </div>
              )}
            </div>
            <div style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 6 }}>{t('snackOpenCashLabel')}</div>
              <input type="number" value={shiftOpenCash} onChange={e => setShiftOpenCash(e.target.value)}
                placeholder="0"
                style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1.5px solid var(--border)', color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 14, outline: 'none' }} />
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={openShift} disabled={shiftLoading || !shiftCashier.trim()} style={{ flex: 1, background: shiftCashier.trim() ? 'var(--green)' : 'rgba(0,255,136,0.2)', border: 'none', color: '#000', padding: '11px', borderRadius: 10, cursor: shiftCashier.trim() ? 'pointer' : 'not-allowed', fontSize: 13, fontWeight: 700 }}>
                {shiftLoading ? '...' : t('snackOpenBtn')}
              </button>
              <button onClick={() => setShiftOpenModal(false)} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '11px 20px', borderRadius: 10, cursor: 'pointer', fontSize: 12 }}>{t('cancelShort')}</button>
            </div>
          </div>
        </div>
      )}

      {/* Smena yopish modali */}
      {shiftCloseModal && currentShift && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16, padding: 32, width: 420 }}>
            <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 20 }}>{t('snackCloseShiftTitle')}</div>
            <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 18px', marginBottom: 20, fontSize: 13 }}>
              <div style={{ marginBottom: 6 }}>{t('snackInfoAdmin')} <b>{currentShift.cashier_name || '—'}</b></div>
              <div style={{ marginBottom: 6 }}>{t('snackInfoOpened')} <b>{new Date(currentShift.opened_at).toLocaleString('uz-UZ', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' })}</b></div>
              <div style={{ marginBottom: 6 }}>{t('snackInfoOpenCash')} <b>{Number(currentShift.opening_cash || 0).toLocaleString()} {t('currency')}</b></div>
              <div style={{ marginBottom: 6 }}>{t('snackInfoOrders')} <b style={{ color: 'var(--cyan)' }}>{t('snackOrderCountFmt').replace('{n}', currentShift.orders_count || 0)}</b></div>
              <div>{t('snackInfoRevenue')} <b style={{ color: 'var(--green)' }}>{Number(currentShift.revenue || 0).toLocaleString()} {t('currency')}</b></div>
            </div>
            <div style={{ marginBottom: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 4 }}>💵 {t('snackCloseCashLabel')}</div>
                <input autoFocus type="number" value={shiftCloseCash} onChange={e => setShiftCloseCash(e.target.value)}
                  placeholder="0"
                  style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1.5px solid var(--border)', color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 14, outline: 'none' }} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 4 }}>📱 Click</div>
                <input type="number" value={shiftCloseClick} onChange={e => setShiftCloseClick(e.target.value)}
                  placeholder="0"
                  style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1.5px solid var(--border)', color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 14, outline: 'none' }} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 4 }}>💳 Payme</div>
                <input type="number" value={shiftClosePayme} onChange={e => setShiftClosePayme(e.target.value)}
                  placeholder="0"
                  style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1.5px solid var(--border)', color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 14, outline: 'none' }} />
              </div>
              <div>
                <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 4 }}>🖨️ Terminal</div>
                <input type="number" value={shiftCloseTerminal} onChange={e => setShiftCloseTerminal(e.target.value)}
                  placeholder="0"
                  style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1.5px solid var(--border)', color: 'var(--text)', padding: '10px 14px', borderRadius: 10, fontSize: 14, outline: 'none' }} />
              </div>
              {(() => {
                const total = (Number(shiftCloseCash) || 0) + (Number(shiftCloseClick) || 0) +
                              (Number(shiftClosePayme) || 0) + (Number(shiftCloseTerminal) || 0);
                return total > 0 ? (
                  <div style={{ background: 'rgba(0,212,255,0.06)', border: '1px solid rgba(0,212,255,0.2)',
                    borderRadius: 10, padding: '10px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 12, color: 'var(--text3)' }}>Jami yopilish summasi</span>
                    <span style={{ fontSize: 15, fontWeight: 700, color: 'var(--cyan)' }}>
                      {total.toLocaleString()} {t('currency')}
                    </span>
                  </div>
                ) : null;
              })()}
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={closeShift} disabled={shiftLoading} style={{ flex: 1, background: 'rgba(239,68,68,0.15)', border: '1.5px solid #ef4444', color: '#ef4444', padding: '11px', borderRadius: 10, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                {shiftLoading ? '...' : t('snackCloseBtn')}
              </button>
              <button onClick={() => setShiftCloseModal(false)} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '11px 20px', borderRadius: 10, cursor: 'pointer', fontSize: 12 }}>{t('cancelShort')}</button>
            </div>
          </div>
        </div>
      )}

      {/* PIN modal */}
      {pinModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16, padding: 32, width: 300, textAlign: 'center' }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>🔒</div>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 20 }}>
              {pinModal === 'change' ? t('snackPinChangeTitle') : t('snackPinEnterTitle')}
            </div>
            <input
              autoFocus
              type="password"
              inputMode="numeric"
              maxLength={6}
              value={pinModal === 'change' ? newPin : pinInput}
              onChange={e => { pinModal === 'change' ? setNewPin(e.target.value) : setPinInput(e.target.value); setPinError(''); }}
              onKeyDown={e => { if (e.key === 'Enter') handlePin(); }}
              placeholder="● ● ● ●"
              style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: `1.5px solid ${pinError ? '#ef4444' : 'var(--border)'}`, color: 'var(--text)', padding: '12px', borderRadius: 10, fontSize: 20, textAlign: 'center', letterSpacing: 8, outline: 'none', marginBottom: 8 }}
            />
            {pinError && <div style={{ color: '#ef4444', fontSize: 12, marginBottom: 8 }}>{pinError}</div>}
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
              <button onClick={handlePin} style={{ flex: 1, background: 'var(--cyan)', border: 'none', color: '#000', padding: '10px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                {pinModal === 'change' ? t('snackPinSave') : t('snackPinLogin')}
              </button>
              <button onClick={() => { setPinModal(false); setPinInput(''); setNewPin(''); setPinError(''); }} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '10px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>{t('cancelShort')}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── MAHSULOTLAR BOSHQARUVI ──────────────────────────────── */}
      {tab === 'products' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginBottom: 16 }}>
            <button onClick={() => { setPinModal('change'); setNewPin(''); setPinError(''); }} style={{
              background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--text3)', padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12,
            }}>{t('snackChangePin')}</button>
            <button onClick={() => { setProductsUnlocked(false); setTab('pos'); }} style={{
              background: 'transparent', border: '1px solid var(--border)',
              color: 'var(--text3)', padding: '7px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 12,
            }}>{t('snackLock')}</button>
            <button onClick={() => setShowAddProduct(!showAddProduct)} style={{
              background: 'rgba(0,212,255,0.1)', border: '1px solid var(--cyan)',
              color: 'var(--cyan)', padding: '7px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 12,
            }}>{t('snackAddProduct')}</button>
          </div>

          {showAddProduct && (
            <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 12, padding: 20, marginBottom: 20 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 6, fontWeight: 600 }}>{t('snackAddEmojiLabel')}</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(10, 1fr)', gap: 6, marginBottom: 12 }}>
                {['🥤','⚡','🥨','🍫','🍔','☕','🍿','🧃','🍦','🍺'].map(e => (
                  <button key={e} onClick={() => setNewProduct(p => ({ ...p, emoji: e }))} style={{
                    fontSize: 18, padding: '6px', borderRadius: 8, cursor: 'pointer',
                    background: newProduct.emoji === e ? 'rgba(0,212,255,0.15)' : 'transparent',
                    border: `1px solid ${newProduct.emoji === e ? 'var(--cyan)' : 'var(--border)'}`,
                  }}>{e}</button>
                ))}
              </div>
              <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 6, fontWeight: 600 }}>{t('snackCategoryLabel')} *</div>
              <select
                value={newProduct.category_id}
                onChange={e => setNewProduct(p => ({ ...p, category_id: e.target.value }))}
                style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginBottom: 10 }}
              >
                <option value="">— {t('snackPickCategory')} —</option>
                {categories.map(c => (
                  <option key={c.id} value={c.id}>{c.icon} {catName(c)}</option>
                ))}
              </select>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 10 }}>
                <input value={newProduct.name} onChange={e => setNewProduct(p => ({ ...p, name: e.target.value }))} placeholder={t('snackNamePlh')}
                  style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12 }} />
                <input value={newProduct.price} onChange={e => setNewProduct(p => ({ ...p, price: e.target.value }))} placeholder={t('snackPricePlh')} type="number"
                  style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12 }} />
                <input value={newProduct.cost_price} onChange={e => setNewProduct(p => ({ ...p, cost_price: e.target.value }))} placeholder={t('snackCostPlh')} type="number"
                  style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12 }} />
                <input value={newProduct.stock} onChange={e => setNewProduct(p => ({ ...p, stock: e.target.value }))} placeholder={t('snackStockPlh')} type="number"
                  style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12 }} />
              </div>
              <div style={{ marginTop: 10 }}>
                <input value={newProduct.barcode} onChange={e => setNewProduct(p => ({ ...p, barcode: e.target.value }))} placeholder={t('snackBarcodePlhAdd')}
                  style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12 }} />
              </div>
              <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                <button onClick={addProduct} style={{ background: 'var(--cyan)', border: 'none', color: '#000', padding: '7px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>{t('save')}</button>
                <button onClick={() => setShowAddProduct(false)} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '7px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>{t('cancelShort')}</button>
              </div>
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
            {products.map(p => (
              <div key={p.id} style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 12, padding: 14, opacity: p.is_active ? 1 : 0.5 }}>
                <div style={{ position: 'relative', height: 90, borderRadius: 8, marginBottom: 8,
                  background: p.image_url ? `url(${p.image_url.startsWith('http') ? p.image_url : (process.env.REACT_APP_API_URL || 'http://localhost:3000/api').replace('/api', '') + p.image_url}) center/cover` : 'rgba(0,212,255,0.05)',
                  border: '1px dashed var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  {!p.image_url && <span style={{ fontSize: 32, opacity: 0.6 }}>{p.emoji}</span>}
                  <label style={{
                    position: 'absolute', bottom: 4, right: 4, background: 'rgba(0,0,0,0.7)',
                    color: 'var(--cyan)', fontSize: 10, padding: '3px 8px', borderRadius: 6,
                    cursor: 'pointer', border: '1px solid var(--cyan)',
                  }}>
                    📷 {p.image_url ? t('snackImgChange') : t('snackImgAdd')}
                    <input type="file" accept="image/*" style={{ display: 'none' }} onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (!file) return;
                      const fd = new FormData();
                      fd.append('photo', file);
                      try {
                        const r = await api.post(`/snack/products/${p.id}/photo`, fd, {
                          headers: { 'Content-Type': 'multipart/form-data' },
                        });
                        setProducts(prev => prev.map(x => x.id === p.id ? { ...x, image_url: r.data.image_url } : x));
                      } catch (err) {
                        alert(err.response?.data?.error || t('snackUploadError'));
                      }
                    }} />
                  </label>
                  {p.image_url && (
                    <button onClick={async () => {
                      if (!window.confirm(t('snackImgDeleteConfirm'))) return;
                      try {
                        await api.delete(`/snack/products/${p.id}/photo`);
                        setProducts(prev => prev.map(x => x.id === p.id ? { ...x, image_url: null } : x));
                      } catch (err) { alert(err.response?.data?.error || t('error')); }
                    }} style={{
                      position: 'absolute', top: 4, right: 4, background: 'rgba(0,0,0,0.7)',
                      color: 'var(--red)', border: '1px solid var(--red)', borderRadius: 6,
                      width: 22, height: 22, cursor: 'pointer', fontSize: 12, padding: 0,
                    }}>✕</button>
                  )}
                  <button
                    disabled={autoFetching === p.id}
                    title={t('snackAutoFindPhotoHint') || 'Open Food Facts\'dan avtomatik rasm topish'}
                    onClick={async () => {
                      if (autoFetching) return;
                      if (p.image_url && !window.confirm(t('snackAutoFindPhotoConfirm') || 'Hozirgi rasm almashtiriladi. Davom etamiz?')) return;
                      setAutoFetching(p.id);
                      try {
                        const r = await api.post(`/snack/products/${p.id}/auto-photo`);
                        setProducts(prev => prev.map(x => x.id === p.id ? { ...x, image_url: r.data.image_url } : x));
                      } catch (err) {
                        alert(err.response?.data?.error || (t('snackAutoFindPhotoError') || 'Rasm topilmadi'));
                      } finally {
                        setAutoFetching(null);
                      }
                    }}
                    style={{
                      position: 'absolute', top: 4, left: 4, background: autoFetching === p.id ? 'rgba(255,193,7,0.9)' : 'rgba(0,0,0,0.7)',
                      color: autoFetching === p.id ? '#000' : 'var(--cyan)', border: `1px solid ${autoFetching === p.id ? '#ffc107' : 'var(--cyan)'}`,
                      borderRadius: 6, padding: '3px 6px', cursor: autoFetching === p.id ? 'wait' : 'pointer',
                      fontSize: 10, fontWeight: 500,
                    }}
                  >
                    {autoFetching === p.id ? '⏳' : '🔍'} {autoFetching === p.id ? (t('snackAutoFindPhotoLoading') || 'Qidiryapti...') : (t('snackAutoFindPhoto') || 'Avto')}
                  </button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                  {editingId === p.id ? (
                    <select value={editForm.emoji} onChange={e => setEditForm(f => ({ ...f, emoji: e.target.value }))}
                      style={{ fontSize: 18, background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', borderRadius: 6, padding: '2px 4px' }}>
                      {['🥤','🍕','🍫','🍔','🥪','🍜','☕','🧃','🍺','🍭','🍩','🍟','🌭','🍦','🥨','🍿'].map(e => (
                        <option key={e} value={e}>{e}</option>
                      ))}
                    </select>
                  ) : (
                    <span style={{ fontSize: 22 }}>{p.emoji}</span>
                  )}
                  <div style={{ display: 'flex', gap: 6 }}>
                    {editingId !== p.id && (
                      <button onClick={() => startEditProduct(p)} title={t('snackEditProduct') || 'Tahrirlash'} style={{
                        fontSize: 10, padding: '2px 8px', borderRadius: 6, cursor: 'pointer',
                        background: 'rgba(0,212,255,0.1)', border: '1px solid var(--cyan)', color: 'var(--cyan)',
                      }}>✏️</button>
                    )}
                    <button onClick={() => api.put(`/snack/products/${p.id}`, { is_active: !p.is_active }).then(() => setProducts(prev => prev.map(x => x.id === p.id ? { ...x, is_active: !x.is_active } : x)))} style={{
                      fontSize: 10, padding: '2px 8px', borderRadius: 6, cursor: 'pointer',
                      background: p.is_active ? 'rgba(0,255,136,0.1)' : 'rgba(255,59,92,0.1)',
                      border: `1px solid ${p.is_active ? 'var(--green)' : 'var(--red)'}`,
                      color: p.is_active ? 'var(--green)' : 'var(--red)',
                    }}>{p.is_active ? t('snackProductActive') : t('snackProductInactive')}</button>
                  </div>
                </div>

                {editingId === p.id ? (
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 }}>
                    <input value={editForm.name} onChange={e => setEditForm(f => ({ ...f, name: e.target.value }))}
                      placeholder={t('snackNamePlh')}
                      style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '6px 10px', borderRadius: 7, fontSize: 12 }} />
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6, minWidth: 0 }}>
                      <input type="number" value={editForm.price} onChange={e => setEditForm(f => ({ ...f, price: e.target.value }))}
                        placeholder={t('snackPricePlh')}
                        style={{ width: '100%', boxSizing: 'border-box', minWidth: 0, background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--green)', padding: '6px 8px', borderRadius: 7, fontSize: 12, fontWeight: 600 }} />
                      <input type="number" value={editForm.cost_price} onChange={e => setEditForm(f => ({ ...f, cost_price: e.target.value }))}
                        placeholder={t('snackCostPlh')}
                        style={{ width: '100%', boxSizing: 'border-box', minWidth: 0, background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--yellow)', padding: '6px 8px', borderRadius: 7, fontSize: 12 }} />
                    </div>
                    <input type="number" value={editForm.stock} onChange={e => setEditForm(f => ({ ...f, stock: e.target.value }))}
                      placeholder={t('snackStockPlh')}
                      style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text2)', padding: '6px 10px', borderRadius: 7, fontSize: 12 }} />
                    <input value={editForm.barcode} onChange={e => setEditForm(f => ({ ...f, barcode: e.target.value }))}
                      placeholder="🔍 Barcode"
                      style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text3)', padding: '6px 10px', borderRadius: 7, fontSize: 11, fontFamily: 'monospace' }} />
                    <select value={editForm.category_id ?? ''} onChange={e => setEditForm(f => ({ ...f, category_id: e.target.value }))}
                      style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '6px 10px', borderRadius: 7, fontSize: 11 }}>
                      <option value="">— {t('snackPickCategory')} —</option>
                      {categories.map(c => (
                        <option key={c.id} value={c.id}>{c.icon} {catName(c)}</option>
                      ))}
                    </select>
                    <div style={{ display: 'flex', gap: 6, marginTop: 4 }}>
                      <button onClick={() => saveEditProduct(p.id)} disabled={editSaving} style={{ flex: 1, minWidth: 0, background: 'var(--cyan)', border: 'none', color: '#000', padding: '6px', borderRadius: 7, cursor: editSaving ? 'wait' : 'pointer', fontSize: 11, fontWeight: 700 }}>
                        {editSaving ? '…' : `💾 ${t('save')}`}
                      </button>
                      <button onClick={cancelEditProduct} disabled={editSaving} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '6px 12px', borderRadius: 7, cursor: 'pointer', fontSize: 11 }}>
                        ✕
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 2 }}>{p.name}</div>
                    <div style={{ fontSize: 12, color: 'var(--green)', fontWeight: 600 }}>{Number(p.price).toLocaleString()} {t('currency')}</div>
                    {Number(p.cost_price) > 0 && (
                      <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 2 }}>
                        {t('snackCostLabel') || 'Tannarx'}: <b style={{ color: 'var(--yellow)' }}>{Number(p.cost_price).toLocaleString()}</b>
                      </div>
                    )}
                    {p.stock > 0 && <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2 }}>{t('snackStockDona').replace('{n}', p.stock)}</div>}
                    {p.barcode && <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 4, fontFamily: 'monospace' }}>🔍 {p.barcode}</div>}
                    {(() => {
                      const cat = categories.find(c => c.id === p.category_id);
                      return (
                        <div style={{ fontSize: 10, marginTop: 4,
                          color: cat ? 'var(--cyan)' : '#ef4444',
                          fontWeight: cat ? 500 : 700 }}>
                          {cat ? `${cat.icon} ${catName(cat)}` : `⚠ ${t('snackNoCategory')}`}
                        </div>
                      );
                    })()}
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── KATEGORIYALAR ───────────────────────────────────────── */}
      {tab === 'cats' && (
        <div>
          <div style={{ marginBottom: 16, color: 'var(--text2)', fontSize: 13 }}>
            {t('snackCatHelp')}
          </div>

          {/* Yangi kategoriya qo'shish */}
          <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 12, padding: 16, marginBottom: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', marginBottom: 10 }}>+ {t('snackCatAddTitle')}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '60px 1fr 1fr 80px auto', gap: 10, alignItems: 'center' }}>
              <input value={newCategory.icon} onChange={e => setNewCategory(c => ({ ...c, icon: e.target.value }))}
                placeholder="🥤" maxLength={2}
                style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px', borderRadius: 8, fontSize: 18, textAlign: 'center' }} />
              <input value={newCategory.name} onChange={e => setNewCategory(c => ({ ...c, name: e.target.value }))}
                placeholder={t('snackCatNameUzPlh')}
                style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12 }} />
              <input value={newCategory.name_ru} onChange={e => setNewCategory(c => ({ ...c, name_ru: e.target.value }))}
                placeholder={t('snackCatNameRuPlh')}
                style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12 }} />
              <input type="number" value={newCategory.sort_order} onChange={e => setNewCategory(c => ({ ...c, sort_order: e.target.value }))}
                placeholder="№"
                style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px', borderRadius: 8, fontSize: 12, textAlign: 'center' }} />
              <button onClick={addCategory}
                style={{ background: 'var(--cyan)', border: 'none', color: '#000', padding: '8px 18px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>
                + {t('add')}
              </button>
            </div>
          </div>

          {/* Mavjud kategoriyalar ro'yxati */}
          <div style={{ display: 'grid', gap: 8 }}>
            {categories.length === 0 && (
              <div style={{ textAlign: 'center', padding: 40, color: 'var(--text3)', fontSize: 13 }}>
                {t('snackCatEmpty')}
              </div>
            )}
            {categories.map(c => {
              const prodCount = products.filter(p => p.category_id === c.id).length;
              const isEditing = editingCatId === c.id;
              return (
                <div key={c.id} style={{
                  background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 10,
                  padding: 14, display: 'grid',
                  gridTemplateColumns: isEditing ? '60px 1fr 1fr 80px auto' : '60px 1fr 1fr 80px 90px auto',
                  gap: 10, alignItems: 'center',
                }}>
                  {isEditing ? (
                    <>
                      <input value={editCatForm.icon} onChange={e => setEditCatForm(f => ({ ...f, icon: e.target.value }))}
                        maxLength={2}
                        style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px', borderRadius: 7, fontSize: 18, textAlign: 'center' }} />
                      <input value={editCatForm.name} onChange={e => setEditCatForm(f => ({ ...f, name: e.target.value }))}
                        style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 7, fontSize: 12 }} />
                      <input value={editCatForm.name_ru} onChange={e => setEditCatForm(f => ({ ...f, name_ru: e.target.value }))}
                        placeholder={t('snackCatNameRuPlh')}
                        style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 7, fontSize: 12 }} />
                      <input type="number" value={editCatForm.sort_order} onChange={e => setEditCatForm(f => ({ ...f, sort_order: e.target.value }))}
                        style={{ background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px', borderRadius: 7, fontSize: 12, textAlign: 'center' }} />
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={saveEditCat}
                          style={{ background: 'var(--cyan)', border: 'none', color: '#000', padding: '7px 14px', borderRadius: 7, cursor: 'pointer', fontSize: 11, fontWeight: 700 }}>💾</button>
                        <button onClick={() => setEditingCatId(null)}
                          style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '7px 12px', borderRadius: 7, cursor: 'pointer', fontSize: 11 }}>✕</button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ fontSize: 24, textAlign: 'center' }}>{c.icon}</div>
                      <div style={{ fontSize: 13, color: 'var(--text)', fontWeight: 600 }}>{c.name}</div>
                      <div style={{ fontSize: 13, color: 'var(--text2)' }}>{c.name_ru || <span style={{ color: '#ef4444' }}>— RU yo'q —</span>}</div>
                      <div style={{ fontSize: 11, color: 'var(--text3)', textAlign: 'center' }}>№ {c.sort_order || 0}</div>
                      <div style={{ fontSize: 11, color: 'var(--text3)', textAlign: 'center' }}>{prodCount} {t('snackCatProductsSuffix')}</div>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => startEditCat(c)}
                          style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid var(--cyan)', color: 'var(--cyan)', padding: '6px 10px', borderRadius: 7, cursor: 'pointer', fontSize: 11 }}>✏️</button>
                        <button onClick={() => deleteCat(c)}
                          style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid #ef4444', color: '#ef4444', padding: '6px 10px', borderRadius: 7, cursor: 'pointer', fontSize: 11 }}>🗑</button>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── SMENA ───────────────────────────────────────────────── */}
      {tab === 'smena' && isAllMode && (
        <div style={{
          background: 'rgba(0,212,255,0.06)', border: '1.5px solid var(--cyan)',
          borderRadius: 14, padding: 32, marginBottom: 20, textAlign: 'center',
        }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🌐</div>
          <div style={{ fontSize: 15, color: 'var(--cyan)', fontWeight: 700, marginBottom: 6 }}>
            {t('selectLabForShift') || 'Smenani boshqarish uchun klubni tanlang'}
          </div>
          <div style={{ fontSize: 12, color: 'var(--text3)' }}>
            {t('allLabs')} — {t('snackShiftModeHint') || 'bu rejimda smena ochish/yopish ishlamaydi'}
          </div>
        </div>
      )}
      {tab === 'smena' && !isAllMode && (
        <div>
          <div style={{ background: currentShift ? 'rgba(0,255,136,0.06)' : 'rgba(239,68,68,0.06)', border: `1.5px solid ${currentShift ? 'var(--green)' : '#ef4444'}`, borderRadius: 14, padding: 24, marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 700, color: currentShift ? 'var(--green)' : '#ef4444', marginBottom: 6 }}>
                {currentShift ? t('snackShiftOpenStatus') : t('snackShiftClosedStatus')}
              </div>
              {currentShift ? (
                <div style={{ fontSize: 12, color: 'var(--text2)', lineHeight: 2 }}>
                  <span style={{ marginRight: 20 }}>{t('snackInfoAdmin')} <b style={{ color: 'var(--text)' }}>{currentShift.cashier_name || '—'}</b></span>
                  <span style={{ marginRight: 20 }}>{t('snackInfoOpened')} <b>{new Date(currentShift.opened_at).toLocaleString('uz-UZ', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' })}</b></span>
                  <br/>
                  <span style={{ marginRight: 20 }}>{t('snackInfoOpenCash')} <b style={{ color: 'var(--cyan)' }}>{Number(currentShift.opening_cash || 0).toLocaleString()} {t('currency')}</b></span>
                  <span style={{ marginRight: 20 }}>{t('snackInfoOrders')} <b style={{ color: 'var(--cyan)' }}>{currentShift.orders_count || 0}</b></span>
                  <span style={{ marginRight: 20 }}>{t('snackSmenaRevenue')} <b style={{ color: 'var(--green)' }}>{Number(currentShift.revenue || 0).toLocaleString()} {t('currency')}</b></span>
                  {Number(currentShift.returns_total) > 0 && (
                    <span>{t('snackSmenaReturns')} <b style={{ color: '#f87171' }}>-{Number(currentShift.returns_total).toLocaleString()} {t('currency')}</b></span>
                  )}
                </div>
              ) : (
                <div style={{ fontSize: 12, color: 'var(--text3)' }}>{t('snackNoShift')}</div>
              )}
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              {currentShift ? (
                <>
                  <button onClick={() => loadShift()} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>
                    {t('snackRefresh')}
                  </button>
                  <button onClick={openCloseShiftModal} style={{ background: 'rgba(239,68,68,0.15)', border: '1.5px solid #ef4444', color: '#ef4444', padding: '8px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700 }}>
                    {t('snackCloseShiftBtn')}
                  </button>
                </>
              ) : (
                <button onClick={() => {
                  setShiftCashier(''); setShiftOpenCash(''); setShiftOpenModal(true);
                  const ownerData = JSON.parse(localStorage.getItem('owner') || '{}');
                  const ownerEntry = ownerData.name ? [{ id: 'owner', name: ownerData.name, role: 'Admin' }] : [];
                  api.get('/staff').then(r => {
                    setStaffList([...ownerEntry, ...(r.data || [])]);
                  }).catch(() => setStaffList(ownerEntry));
                }} style={{ background: 'rgba(0,255,136,0.15)', border: '1.5px solid var(--green)', color: 'var(--green)', padding: '8px 24px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>
                  {t('snackOpenShiftBtn')}
                </button>
              )}
            </div>
          </div>

          {currentShift && (
            <div>
              <div style={{ fontSize: 11, color: 'var(--text3)', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 12 }}>
                {t('snackShiftOrdersTitle').replace('{n}', shiftOrders.length)}
              </div>
              {shiftOrders.length === 0 ? (
                <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 12, padding: 32, textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>
                  {t('snackNoOrdersYet')}
                </div>
              ) : shiftOrders.map(order => (
                <div key={order.id} style={{ background: 'var(--card2)', border: `1px solid ${order.is_debt ? 'rgba(239,68,68,0.3)' : 'var(--border)'}`, borderRadius: 12, padding: '14px 18px', marginBottom: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                    <div>
                      <span style={{ fontFamily: 'Orbitron, sans-serif', fontSize: 12, color: 'var(--cyan)', fontWeight: 700 }}>#{order.id}</span>
                      {order.computer_number && <span style={{ fontSize: 11, color: 'var(--text3)', marginLeft: 10 }}>PC {order.computer_number}</span>}
                      {order.is_debt && <span style={{ fontSize: 11, color: '#ef4444', marginLeft: 10, fontWeight: 700 }}>{t('snackDebtOrderBadge')}{order.user_name ? ` · ${order.user_name}` : ''}</span>}
                      <span style={{ fontSize: 11, color: 'var(--text3)', marginLeft: 10 }}>{new Date(order.created_at).toLocaleTimeString('uz-UZ', { hour: '2-digit', minute: '2-digit' })}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <span style={{ fontWeight: 700, color: 'var(--green)', fontSize: 14 }}>{Number(order.total).toLocaleString()} {t('currency')}</span>
                      <button onClick={() => openReturnModal(order)} style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.4)', color: '#f87171', padding: '4px 12px', borderRadius: 7, cursor: 'pointer', fontSize: 11 }}>
                        {t('snackReturnBtn')}
                      </button>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {(order.items || []).map((item, i) => (
                      <span key={i} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 6, padding: '3px 8px', fontSize: 11, color: 'var(--text2)' }}>
                        {item.product_name} ×{item.qty} — {Number(item.subtotal).toLocaleString()}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* ── SMENA TARIXI ─────────────────────────────────────── */}
          <div style={{ marginTop: 36 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', letterSpacing: 2, textTransform: 'uppercase' }}>
                📚 {t('snackShiftHistoryTitle') || 'Smena tarixi'} ({shiftHistory.filter(s => s.status !== 'open').length})
              </div>
              <button onClick={loadShiftHistory} disabled={historyLoading} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '6px 14px', borderRadius: 8, cursor: 'pointer', fontSize: 11 }}>
                {historyLoading ? '…' : t('snackRefresh')}
              </button>
            </div>

            {historyLoading && shiftHistory.length === 0 ? (
              <div style={{ padding: 24, textAlign: 'center', color: 'var(--text3)', fontSize: 12 }}>{t('loading')}</div>
            ) : shiftHistory.filter(s => s.status !== 'open').length === 0 ? (
              <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 12, padding: 24, textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>
                {t('snackShiftHistoryEmpty') || "Hali yopilgan smena yo'q"}
              </div>
            ) : shiftHistory.filter(s => s.status !== 'open').map(sh => {
              const isExpanded = expandedShiftId === sh.id;
              const orders = historyOrders[sh.id] || [];
              const duration = sh.closed_at
                ? Math.round((new Date(sh.closed_at) - new Date(sh.opened_at)) / 60000)
                : null;
              return (
                <div key={sh.id} style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 12, marginBottom: 10, overflow: 'hidden' }}>
                  <div
                    onClick={() => toggleShiftDetails(sh.id)}
                    style={{ padding: '14px 18px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
                      <span style={{ fontFamily: 'Orbitron, sans-serif', fontSize: 12, color: 'var(--text3)' }}>#{sh.id}</span>
                      <b style={{ fontSize: 13, color: 'var(--text)' }}>{sh.cashier_name || '—'}</b>
                      <span style={{ fontSize: 11, color: 'var(--text3)' }}>
                        🕐 {new Date(sh.opened_at).toLocaleString('uz-UZ', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                        {sh.closed_at && <> → {new Date(sh.closed_at).toLocaleString('uz-UZ', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}</>}
                        {duration !== null && <span style={{ marginLeft: 6, color: 'var(--text2)' }}>({duration >= 60 ? `${Math.floor(duration / 60)}s ${duration % 60}d` : `${duration}d`})</span>}
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
                      <span style={{ fontSize: 12, color: 'var(--text2)' }}>📋 <b>{sh.orders_count || 0}</b></span>
                      <span style={{ fontSize: 12, color: 'var(--green)', fontWeight: 700 }}>💵 {Number(sh.revenue || 0).toLocaleString()}</span>
                      {(sh.returns_count > 0 || Number(sh.returns_total) > 0) && (
                        <span style={{ fontSize: 12, color: '#f87171' }}>
                          ↩ {sh.returns_count || 0} ({Number(sh.returns_total || 0).toLocaleString()})
                        </span>
                      )}
                      <span style={{ fontSize: 14, color: 'var(--text3)' }}>{isExpanded ? '▲' : '▼'}</span>
                    </div>
                  </div>

                  {isExpanded && (
                    <div style={{ borderTop: '1px solid var(--border)', padding: '14px 18px', background: 'var(--bg2)' }}>
                      {!historyOrders[sh.id] ? (
                        <div style={{ padding: 12, textAlign: 'center', color: 'var(--text3)', fontSize: 12 }}>{t('loading')}</div>
                      ) : orders.length === 0 ? (
                        <div style={{ padding: 12, textAlign: 'center', color: 'var(--text3)', fontSize: 12 }}>
                          {t('snackNoOrdersYet') || "Buyurtma yo'q"}
                        </div>
                      ) : (
                        <>
                          <div style={{ fontSize: 10, color: 'var(--text3)', letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 10 }}>
                            {orders.length} {t('snackOrdersLabel') || 'ta buyurtma'}
                          </div>
                          {orders.map(order => (
                            <div key={order.id} style={{ background: 'var(--card2)', border: `1px solid ${order.is_debt ? 'rgba(239,68,68,0.3)' : 'var(--border)'}`, borderRadius: 10, padding: '10px 14px', marginBottom: 8 }}>
                              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, flexWrap: 'wrap', gap: 8 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                  <span style={{ fontFamily: 'Orbitron, sans-serif', fontSize: 11, color: 'var(--cyan)', fontWeight: 700 }}>#{order.id}</span>
                                  {order.computer_number && <span style={{ fontSize: 10, color: 'var(--text3)' }}>PC {order.computer_number}</span>}
                                  {order.is_debt && <span style={{ fontSize: 10, color: '#ef4444', fontWeight: 700 }}>{t('snackDebtOrderBadge')}{order.user_name ? ` · ${order.user_name}` : ''}</span>}
                                  <span style={{ fontSize: 10, color: 'var(--text3)' }}>{new Date(order.created_at).toLocaleTimeString('uz-UZ', { hour: '2-digit', minute: '2-digit' })}</span>
                                  <span style={{ fontSize: 10, color: order.status === 'paid' ? 'var(--green)' : 'var(--text3)' }}>· {order.status}</span>
                                </div>
                                <span style={{ fontWeight: 700, color: 'var(--green)', fontSize: 13 }}>{Number(order.total).toLocaleString()} {t('currency')}</span>
                              </div>
                              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                {(order.items || []).filter(i => i && i.id).map((item, i) => (
                                  <span key={i} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 6, padding: '2px 8px', fontSize: 10, color: 'var(--text2)' }}>
                                    {item.product_name} ×{item.qty} — <b>{Number(item.subtotal).toLocaleString()}</b>
                                  </span>
                                ))}
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Vazvrat uchun buyurtma tanlash modali */}
      {returnListModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setReturnListModal(false)}>
          <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16, padding: 24, width: 540, maxHeight: '80vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div style={{ fontSize: 15, fontWeight: 700 }}>↩ {t('snackReturnSelectTitle') || "Qaysi buyurtmadan qaytarish?"}</div>
              <button onClick={() => setReturnListModal(false)} style={{ background: 'transparent', border: 'none', color: 'var(--text3)', fontSize: 20, cursor: 'pointer', padding: 0 }}>✕</button>
            </div>

            {paidLoading ? (
              <div style={{ padding: 40, textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>{t('loading')}</div>
            ) : paidOrders.length === 0 ? (
              <div style={{ padding: 40, textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>
                {t('snackNoReturnableOrders') || "To'langan buyurtma topilmadi"}
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {paidOrders.map(order => (
                  <button key={order.id} onClick={() => selectOrderForReturn(order)}
                    style={{ textAlign: 'left', background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 10, padding: '12px 14px', cursor: 'pointer', color: 'var(--text)' }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = 'var(--cyan)'}
                    onMouseLeave={e => e.currentTarget.style.borderColor = 'var(--border)'}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, flexWrap: 'wrap', gap: 6 }}>
                      <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                        <span style={{ fontFamily: 'Orbitron, sans-serif', fontSize: 12, color: 'var(--cyan)', fontWeight: 700 }}>#{order.id}</span>
                        {order.computer_number && <span style={{ fontSize: 11, color: 'var(--text3)' }}>PC {order.computer_number}</span>}
                        {order.user_name && <span style={{ fontSize: 11, color: 'var(--text2)' }}>👤 {order.user_name}</span>}
                        <span style={{ fontSize: 11, color: 'var(--text3)' }}>
                          {new Date(order.paid_at || order.created_at).toLocaleString('uz-UZ', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                        </span>
                      </div>
                      <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--green)' }}>{Number(order.total).toLocaleString()} {t('currency')}</span>
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                      {(order.items || []).filter(i => i && i.id).map((item, i) => (
                        <span key={i} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 6, padding: '2px 8px', fontSize: 10, color: 'var(--text2)' }}>
                          {item.product_name} ×{item.qty}
                        </span>
                      ))}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Qaytarish modali */}
      {returnModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 16, padding: 28, width: 460, maxHeight: '80vh', overflowY: 'auto' }}>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 20 }}>{t('snackReturnTitle').replace('{n}', returnModal.id)}</div>
            <div style={{ marginBottom: 16 }}>
              {(returnModal.items || []).map(item => (
                <div key={item.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{item.product_name}</div>
                    <div style={{ fontSize: 11, color: 'var(--text3)' }}>{t('snackSoldInfo').replace('{qty}', item.qty).replace('{price}', Number(item.price).toLocaleString())}</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 11, color: 'var(--text3)' }}>{t('snackReturnQtyLabel')}</span>
                    <button onClick={() => setReturnItems(p => ({ ...p, [item.id]: Math.max(0, (p[item.id] || 0) - 1) }))} style={{ width: 26, height: 26, borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text)', cursor: 'pointer' }}>−</button>
                    <span style={{ fontSize: 13, minWidth: 20, textAlign: 'center', color: returnItems[item.id] > 0 ? '#ef4444' : 'var(--text3)' }}>{returnItems[item.id] || 0}</span>
                    <button onClick={() => setReturnItems(p => ({ ...p, [item.id]: Math.min(item.qty, (p[item.id] || 0) + 1) }))} style={{ width: 26, height: 26, borderRadius: 6, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text)', cursor: 'pointer' }}>+</button>
                  </div>
                </div>
              ))}
            </div>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#f87171', marginBottom: 12 }}>
              {t('snackReturnTotal')} {Number((returnModal.items || []).reduce((s, i) => s + i.price * (returnItems[i.id] || 0), 0)).toLocaleString()} {t('currency')}
            </div>
            <input value={returnReason} onChange={e => setReturnReason(e.target.value)} placeholder={t('snackReturnReasonPlh')} style={{ width: '100%', boxSizing: 'border-box', background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '8px 12px', borderRadius: 8, fontSize: 12, marginBottom: 16 }} />
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={submitReturn} style={{ flex: 1, background: '#ef4444', border: 'none', color: '#fff', padding: '10px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>{t('snackReturnConfirm')}</button>
              <button onClick={() => setReturnModal(null)} style={{ background: 'transparent', border: '1px solid var(--border)', color: 'var(--text2)', padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 12 }}>{t('cancelShort')}</button>
            </div>
          </div>
        </div>
      )}

      {/* ── KAMOMAD (INVENTARIZATSIYA) ──────────────────────────── */}
      {tab === 'shortage' && (
        <div>
          <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
            <button onClick={() => { setInvMode('history'); api.get('/snack/inventory').then(r => setInvHistory(r.data)).catch(()=>{}); }} style={{ padding: '7px 18px', borderRadius: 8, fontSize: 12, cursor: 'pointer', background: invMode==='history' ? 'rgba(0,212,255,0.1)' : 'transparent', border: `1px solid ${invMode==='history' ? 'var(--cyan)' : 'var(--border)'}`, color: invMode==='history' ? 'var(--cyan)' : 'var(--text2)' }}>{t('snackInvHistory')}</button>
            <button onClick={() => {
              setInvMode('check');
              api.get('/snack/shortage').then(r => {
                setShortage(r.data);
                const counts = {};
                r.data.forEach(p => { counts[p.id] = p.actual_stock; });
                setInvCounts(counts);
              }).catch(()=>{});
            }} style={{ padding: '7px 18px', borderRadius: 8, fontSize: 12, cursor: 'pointer', background: invMode==='check' ? 'rgba(239,68,68,0.1)' : 'transparent', border: `1px solid ${invMode==='check' ? '#ef4444' : 'var(--border)'}`, color: invMode==='check' ? '#ef4444' : 'var(--text2)' }}>{t('snackInvNew')}</button>
          </div>

          {invMode === 'history' && (
            <div>
              {invHistory.length === 0 ? (
                <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 14, padding: 40, textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>
                  {t('snackInvEmpty')}
                </div>
              ) : invHistory.map(c => (
                <div key={c.id} style={{ background: 'var(--card2)', border: `1px solid ${Number(c.shortage_count) > 0 ? 'rgba(239,68,68,0.3)' : 'var(--border)'}`, borderRadius: 12, padding: '14px 18px', marginBottom: 10, cursor: 'pointer' }}
                  onClick={async () => {
                    if (invDetail?.id === c.id) { setInvDetail(null); return; }
                    const r = await api.get(`/snack/inventory/${c.id}`);
                    setInvDetail(r.data);
                  }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)' }}>
                        {new Date(c.checked_at).toLocaleString('uz-UZ', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' })}
                      </span>
                      {c.shift_opened && <span style={{ fontSize: 11, color: 'var(--text3)', marginLeft: 12 }}>Smena: {new Date(c.shift_opened).toLocaleString('uz-UZ', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' })}</span>}
                      {c.cashier_name && <span style={{ fontSize: 11, color: 'var(--cyan)', marginLeft: 12 }}>👤 {c.cashier_name}</span>}
                      {c.note && <span style={{ fontSize: 11, color: 'var(--text3)', marginLeft: 12 }}>· {c.note}</span>}
                    </div>
                    <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                      {Number(c.shortage_count) > 0 ? (
                        <span style={{ fontSize: 12, fontWeight: 700, color: '#ef4444', background: 'rgba(239,68,68,0.1)', padding: '3px 10px', borderRadius: 6 }}>
                          {t('snackShortageCount').replace('{n}', c.shortage_count).replace('{total}', c.total_shortage)}
                        </span>
                      ) : (
                        <span style={{ fontSize: 12, color: 'var(--green)', fontWeight: 600 }}>{t('snackNoShortage')}</span>
                      )}
                      <span style={{ fontSize: 11, color: 'var(--text3)' }}>{invDetail?.id === c.id ? '▲' : '▼'}</span>
                    </div>
                  </div>
                  {invDetail?.id === c.id && (
                    <div style={{ marginTop: 14, borderTop: '1px solid var(--border)', paddingTop: 12 }}>
                      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 0, background: 'var(--bg2)', borderRadius: 8, overflow: 'hidden' }}>
                        {[t('snackInvColProduct'), t('snackInvColExpected'), t('snackInvColActual'), t('snackInvColDiff')].map(h => (
                          <div key={h} style={{ padding: '8px 12px', fontSize: 10, color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: 1, borderBottom: '1px solid var(--border)', fontWeight: 600 }}>{h}</div>
                        ))}
                        {(invDetail.items || []).map(item => {
                          const d = Number(item.difference);
                          return [
                            <div key={`${item.id}-n`} style={{ padding: '8px 12px', borderBottom: '1px solid var(--border)', fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 }}>
                              {item.product_name}
                              {d < 0 && <span style={{ fontSize: 9, background: 'rgba(239,68,68,0.15)', color: '#ef4444', padding: '1px 5px', borderRadius: 3, fontWeight: 700 }}>{t('snackKamomad')}</span>}
                            </div>,
                            <div key={`${item.id}-e`} style={{ padding: '8px 12px', borderBottom: '1px solid var(--border)', fontSize: 12, color: 'var(--text2)' }}>{item.expected_qty}</div>,
                            <div key={`${item.id}-a`} style={{ padding: '8px 12px', borderBottom: '1px solid var(--border)', fontSize: 12, color: d < 0 ? '#ef4444' : 'var(--green)', fontWeight: 600 }}>{item.actual_qty}</div>,
                            <div key={`${item.id}-d`} style={{ padding: '8px 12px', borderBottom: '1px solid var(--border)', fontSize: 12, fontWeight: 700, color: d < 0 ? '#ef4444' : d > 0 ? '#f59e0b' : 'var(--text3)' }}>{d > 0 ? `+${d}` : d}</div>,
                          ];
                        })}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {invMode === 'check' && (
            <div>
              <div style={{ background: 'rgba(239,68,68,0.05)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 12, padding: '12px 16px', marginBottom: 16, fontSize: 12, color: 'var(--text2)' }}>
                {t('snackInvHint')}
              </div>

              <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 14, overflow: 'hidden', marginBottom: 16 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 0 }}>
                  {[t('snackInvColProduct'), t('snackInvColSystem'), t('snackInvColInput'), t('snackInvColDiff')].map(h => (
                    <div key={h} style={{ padding: '10px 16px', fontSize: 11, color: 'var(--text3)', letterSpacing: 1, textTransform: 'uppercase', borderBottom: '1px solid var(--border)', background: 'var(--bg2)', fontWeight: 600 }}>{h}</div>
                  ))}
                  {shortage.map(p => {
                    const actual = invCounts[p.id] !== undefined ? Number(invCounts[p.id]) : Number(p.actual_stock);
                    const expected = Number(p.actual_stock);
                    const diff = actual - expected;
                    return [
                      <div key={`${p.id}-n`} style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                        <span>{p.emoji}</span><span style={{ fontWeight: 600 }}>{p.name}</span>
                      </div>,
                      <div key={`${p.id}-e`} style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', fontSize: 13, color: 'var(--cyan)', display: 'flex', alignItems: 'center' }}>{p.actual_stock}</div>,
                      <div key={`${p.id}-i`} style={{ padding: '6px 12px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center' }}>
                        <input
                          type="number" min="0"
                          value={invCounts[p.id] !== undefined ? invCounts[p.id] : p.actual_stock}
                          onChange={e => setInvCounts(prev => ({ ...prev, [p.id]: e.target.value }))}
                          style={{ width: 70, background: 'var(--bg2)', border: `1.5px solid ${diff < 0 ? '#ef4444' : diff > 0 ? '#f59e0b' : 'var(--border)'}`, color: 'var(--text)', padding: '5px 8px', borderRadius: 7, fontSize: 13, textAlign: 'center' }}
                        />
                      </div>,
                      <div key={`${p.id}-d`} style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', fontSize: 13, fontWeight: 700, display: 'flex', alignItems: 'center', color: diff < 0 ? '#ef4444' : diff > 0 ? '#f59e0b' : 'var(--text3)' }}>
                        {diff !== 0 ? (diff > 0 ? `+${diff}` : diff) : '—'}
                      </div>,
                    ];
                  })}
                </div>
              </div>

              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <input value={invNote} onChange={e => setInvNote(e.target.value)} placeholder={t('snackInvNotePlh')}
                  style={{ flex: 1, background: 'var(--bg2)', border: '1px solid var(--border)', color: 'var(--text)', padding: '9px 14px', borderRadius: 8, fontSize: 12 }} />
                <button disabled={invSaving} onClick={async () => {
                  setInvSaving(true);
                  try {
                    const items = shortage.map(p => ({
                      product_id: p.id,
                      product_name: p.name,
                      expected_qty: Number(p.actual_stock),
                      actual_qty: invCounts[p.id] !== undefined ? Number(invCounts[p.id]) : Number(p.actual_stock),
                    }));
                    await api.post('/snack/inventory', {
                      lab_id: labId,
                      shift_id: currentShift?.id || null,
                      items,
                      note: invNote,
                    });
                    setInvNote('');
                    setInvMode('history');
                    const [sh, hist, prod] = await Promise.all([
                      api.get('/snack/shortage'),
                      api.get('/snack/inventory'),
                      api.get('/snack/products?active=true'),
                    ]);
                    setShortage(sh.data);
                    setInvHistory(hist.data);
                    setProducts(prod.data.filter(x => x.lab_id === labId));
                  } catch(e) { alert(e.response?.data?.error || t('error')); }
                  finally { setInvSaving(false); }
                }} style={{ background: '#ef4444', border: 'none', color: '#fff', padding: '9px 24px', borderRadius: 8, cursor: invSaving ? 'not-allowed' : 'pointer', fontSize: 13, fontWeight: 700, opacity: invSaving ? 0.6 : 1 }}>
                  {invSaving ? '...' : t('snackInvSave')}
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ── STATISTIKA ──────────────────────────────────────────── */}
      {tab === 'stats' && stats && (
        <div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
            {[
              { icon: '📋', value: stats.orders_today || 0, label: t('snackStatsTodayOrders'), color: 'var(--cyan)' },
              { icon: '💰', value: `${Number(stats.revenue_today || 0).toLocaleString()} ${t('currency')}`, label: t('snackStatsTodayRevenue'), color: 'var(--green)' },
              { icon: '🕐', value: stats.open_orders || 0, label: t('snackStatsOpenOrders'), color: 'var(--orange)' },
            ].map(k => (
              <div key={k.label} style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 14, padding: 20 }}>
                <div style={{ fontSize: 24, marginBottom: 8 }}>{k.icon}</div>
                <div style={{ fontFamily: 'Orbitron, sans-serif', fontSize: 20, fontWeight: 700, color: k.color }}>{k.value}</div>
                <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 4 }}>{k.label}</div>
              </div>
            ))}
          </div>

          {stats.top_products && (
            <div style={{ background: 'var(--card2)', border: '1px solid var(--border)', borderRadius: 14, overflow: 'hidden' }}>
              <div style={{ padding: '12px 20px', borderBottom: '1px solid var(--border)', fontSize: 11, color: 'var(--text2)', letterSpacing: 2, textTransform: 'uppercase' }}>{t('snackTopProducts')}</div>
              {stats.top_products.map((p, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 20px', borderBottom: '1px solid var(--border)' }}>
                  <span style={{ fontSize: 13 }}>{p.product_name}</span>
                  <div style={{ display: 'flex', gap: 20, fontSize: 12 }}>
                    <span style={{ color: 'var(--text2)' }}>{p.qty} {t('snackDona')}</span>
                    <span style={{ color: 'var(--green)', fontWeight: 600 }}>{Number(p.revenue).toLocaleString()} {t('currency')}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
